// Shared helpers for the post-auth redirect machinery. Extracted to keep
// `AuthForm.client` and `AuthPage.client` in sync — both surfaces drive the
// same flow and used to drift independently when fixes only touched one.

const PROFILE_SETUP_PATH = '/mijn/profiel/aanmaken'

// Forwards a captured deep-link target through the profile-setup detour by
// appending it as `?r=`. The setup page reads `r` back into Zustand on mount
// and consumes it after the user finishes the form.
export function buildProfileSetupUrl(pendingRedirect: string | null): string {
  if (!pendingRedirect) return PROFILE_SETUP_PATH
  return `${PROFILE_SETUP_PATH}?r=${encodeURIComponent(pendingRedirect)}`
}

// Picks the intent string passed to `sendMagicLink`. Business intents (set by
// the caller, e.g. `create-script:…`) always win. If none is set but the auth
// flow carries a captured deep link, encode it as a `return:` intent so the
// server-side verify route can land the user there — Zustand isn't visible to
// the server.
export function buildMagicLinkIntent(
  intent: string | undefined,
  redirectPath: string | undefined,
): string | undefined {
  if (intent) return intent
  if (redirectPath) return `return:${redirectPath}`
  return undefined
}
